// @core/api/endpoints/affiliate/approve_payout.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ApprovePayoutRequest,
  PayoutResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Approve payout
 * Performs approve operation on payout.
 */
export async function ApprovePayout(
  payout_id: string,
  data: ApprovePayoutRequest,
  options?: RequestOptions
): Promise<PayoutResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payouts/:payout_id/approve`;
  requestPath = requestPath.replace(':payout_id', encodeURIComponent(payout_id));
  const requestOptions = options;
  return client.post<PayoutResponse>(requestPath, data, requestOptions);
}
